module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/synthesizer.png?720a6f28506780a9d974b3bf24d5d16a";